@let _totalProducts = totalProducts();
@let _checkoutTotalData = checkoutTotalData();
@let _modalNoteTitleLevel = modalNoteTitleLevel();
@let _isShippingFree = isShippingFree();
@let _extraLegals = extraLegals();
@let _step = step();

<sd-border-wrapper
  customClass="bold brand--h4"
  [title]="'checkout.total.total' | translate"
  [textConfig]="textPosition()"
  [titleLevel]="titleLevel()"
  data-testid="checkout-total"
>
  <div class="c__wrapper">
    <ul>
      <li class="is-caption" data-testid="subtotal">
        <span>{{ (_totalProducts > 1 ? 'checkout.subtotal.articles' : 'checkout.subtotal.article') | translate: {'article': _totalProducts} }}</span>
        <span class="is-semi-bold c__price">{{ _checkoutTotalData?.subtotal }}</span>
      </li>
      @if (displayShippingFees()) {
        <li class="is-caption" data-testid="fees">
          <span>{{ 'checkout.total.shippingCosts' | translate }}</span>
          <span class="{{ _isShippingFree ? 'is-promo-1' : '' }} is-semi-bold c__price">
            {{ _isShippingFree ? ('checkout.total.free' | translate) : _checkoutTotalData?.shippingCosts }}
          </span>
        </li>
      }
      @if (displayPaymentFees()) {
        <li class="is-caption">
          <span>{{ 'checkout.total.paymentCosts' | translate }}</span>
          <span class="is-semi-bold c__price">
            {{ _checkoutTotalData.paymentCosts }}
          </span>
        </li>
      }
      <li class="is-caption is-total d-block" data-testid="total">
        <div class="total-ttc d-flex justify-content-between">
          <span class="is-bold is-body-m">{{ 'checkout.total.totalTtc' | translate }}</span>
          <span class="is-bold brand--h4 c__price">
            {{ _checkoutTotalData?.total }}
            <sd-converted-price class="is-text-right is-block" [price]="_checkoutTotalData?.total" />
          </span>
        </div>
        @if (_checkoutTotalData?.ecoPart) {
          <div class="is-caption eco-part d-flex justify-content-between align-items-center">
            <span>{{ 'checkout.total.ecoPart' | translate }}</span>
            <span class="is-semi-bold c__price">{{ _checkoutTotalData?.ecoPart }}</span>
          </div>
        }
      </li>
      @if (readonly()) {
        <li class="is-caption is-payment-mode">
          @if (_checkoutTotalData?.paymentProvider && _checkoutTotalData?.selectedPaymentMode) {
            <span class="is-semi-bold">
              {{ 'checkout.total.paymentMode' | translate }}
            </span>
            <span class="is-bold c__mode">
              {{ 'payment.method.' + (_checkoutTotalData?.paymentProvider | lowercase) + '.' + _checkoutTotalData?.selectedPaymentMode+'.name' | translate }}
            </span>
          }
        </li>
      }
    </ul>

    @if (promos()?.length > 0) {
      <ul sd-list-block class="c__promos is-xs">
        @for (promo of promos(); track promo) {
          <li>
            <sd-product-promo [promo]="promo" (learnMoreClick)="onPromoClick($event)" />
          </li>
        }
      </ul>
    }

    @if (!readonly()) {
      @if (_step === checkoutStepsEnum.payments || isExpressOrderReview()) {
        <sd-form checkbox
          #checkboxTerms
          class="is-aligned-top"
          (change)="updateForms()"
          [labelTitle]="legalTermsTranslation | translate"
          nameField="legalsTermsCheckout"
          [required]="true"
        />
      }
      @if (_extraLegals) {
        <sd-html
          #extraLegals
          innerClass="is-caption c__extra-legals is-wysiwyg"
          [html]="'checkout.total.extraLegalTerms' | translate"
        />
      }
      @if (!isPaypal() && !isApplePay()) {
        <button sd-button
          type="button"
          [disabled]="proceedDisabled() || ((_step === checkoutStepsEnum.payments || isExpressOrderReview()) && !checkboxTerms()?.checked)"
          (click)="checkTerms(checkoutEnum.account)"
        >
          {{ buttonProperties() | translate : { total: _checkoutTotalData?.total } }}
        </button>
      }
      @if (guestCheckout()) {
        <button sd-button
          type="button"
          (click)="checkTerms(checkoutEnum.guest)"
          [isSecondary]="true"
        >
          {{ 'checkout.total.checkoutGuest' | translate }}
        </button>
      }
      @if (paypalCheckout()) {
        <button sd-button
          class="c__btn-paypal"
          type="button"
          (click)="checkTerms(checkoutEnum.paypal)"
          [isSecondary]="true"
        >
        <img src="data:image/svg+xml;base64,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"/>
        <span class="is-semi-bold">{{ 'checkout.total.checkout' | translate }}</span>
      </button>
    }
  }

    @if (_checkoutTotalData?.errorMessage) {
      <p class="c__error-message is-caption" [attr.data-color]="'error-base'">
        {{_checkoutTotalData?.errorMessage}}
      </p>
    }

    <ng-content select="[sd-additional-button]" />

    @if (_checkoutTotalData?.klarnaData && !_checkoutTotalData?.dividedData) {
      <klarna-placement
        data-key="credit-promotion-badge"
        [attr.data-locale]="_checkoutTotalData?.klarnaData.locale"
        [attr.data-purchase-amount]="_checkoutTotalData?.klarnaData.price"
      />
    }

    <ng-content select="[sd-additional-informations]" />
  </div>
</sd-border-wrapper>

<div class="c__additional-elements">
  <ng-content select="[sd-additional-elements]" />

  @if (_checkoutTotalData?.dividedData) {
    <sd-divided-payment
      [dividedData]="_checkoutTotalData?.dividedData"
      (dividedClick)="onDividedClick()"
    />
  }
</div>

<sd-modal-default
  [(isOpened)]="isOpened"
  (closed)="onClose()"
  [modalTitle]="'checkout.total.termsOfSale' | translate"
  [modalTitleLevel]="_modalNoteTitleLevel"
  data-testid="terms-modal"
>
  <router-outlet name="modal" />
</sd-modal-default>

<sd-modal-default
  [(isOpened)]="mandatoryCheck"
  [modalTitle]="'checkout.total.modalNotify' | translate"
  [modalTitleLevel]="_modalNoteTitleLevel"
  data-testid="mandatory-modal"
>
  <p>{{ 'checkout.total.mandatoryCheckbox' | translate }}</p>
  <footer class="c__modal-actions" sd-modal-footer>
    <button type="button" sd-button (click)="toggleModalNote()">
      <span>{{ 'checkout.total.modalNotifyClose' | translate }}</span>
    </button>
  </footer>
</sd-modal-default>
